import { __decorate } from "tslib";
import Vue from 'vue';
import { Component, Watch } from 'vue-property-decorator';
import Drawer from '@blade/common/components/task-management/paint.vue';
// import maputil from '@blade/common-ui/map-old/2d/src/components/drawer-map/index.vue';
import maputil from '@blade-sxp/map/components/index.vue';
import { setCustomOptions } from '@blade-sxp/task-management/constant/drawer-options';
import { fetchMapDetail } from '@blade/common-ui/map-old/2d/src/api/index';
import { getQueryDeviceDetail } from '@blade-sxp/task-management/api/creat-task/index';
import { isEmpty, cloneDeep } from 'lodash';
import VideoDrawer from '@blade/common/components/task-management/simple-drawer.vue';
// import VideoDrawer from '@blade/common/components/task-management/paint.vue';
import { DeviceIdDataModule } from '@blade-sxp/task-management/store/deviceIdData';
import { MapPolygonsModule } from '@blade-sxp/task-management/store/mapPolygons';
import MapDeviceIcon from '@blade-sxp/map-management/pages/2d/components/map/device.vue';
const Service = { fetchMapDetail, getQueryDeviceDetail };
// interface MapROI {
//   id: string;
//   name: string;
//   vertices: Ivertice[];
// }
let MarkMap = class MarkMap extends Vue {
    isPlayFlag = true;
    limits = {};
    options = setCustomOptions('polygon');
    directionConfig = {};
    paintState = false;
    styleProp = {
        width: 489,
        height: 378,
    };
    specifiedStyle = {};
    showSelect = false;
    buttons = ['polygon'];
    loading = false;
    backgroundURL = '';
    deviceList = [];
    zoneListLinked = [];
    isPlay = true;
    drawButtons = ['polygon', 'rect'];
    rtspAddress = '';
    polygons = [];
    stylePropMap = {
        width: 385,
        height: 233,
    };
    uncheckedImg = require('@blade-sxp/task-management/assets/subtract.png');
    selectImg = require('@blade-sxp/task-management/assets/select.png');
    drawedImg = require('@blade-sxp/task-management/assets/light.png');
    noDrawedImg = require('@blade-sxp/task-management/assets/wite-hilgt.png');
    polygonsMapData = [];
    selectActive = -1;
    mapId = '';
    progress = 0;
    loadings = false;
    mapType = '';
    mapUrl = '';
    // isLoading: boolean = false;
    roiList = [];
    deviceId = '';
    list = [];
    roiMap = {};
    isShow = false;
    mapConfig = { configJson: '' };
    showPoints = false;
    mode = 'normal';
    get mainAngle() {
        try {
            return JSON.parse(this.mapConfig?.configJson);
        }
        catch (e) {
            return null;
        }
    }
    get getCrrentDeviceId() {
        return DeviceIdDataModule.deviceId;
    }
    get getCrrentRoi() {
        let roi = [];
        const roiData = DeviceIdDataModule.deviceIdRequestParams.get(this.getCrrentDeviceId);
        if (!isEmpty(roiData)) {
            roiData.titleList.forEach((item) => {
                if (item.type === 'ROI') {
                    roi = item.data;
                }
            });
        }
        return roi;
    }
    get getCrrentRoiMap() {
        return DeviceIdDataModule.markMapData;
    }
    get getCrrentRtspUrl() {
        return DeviceIdDataModule.currentRtspUrl;
    }
    get mouseBgClass() {
        let polygonPoints = MapPolygonsModule.currPolygonPoints;
        // if (!this.showPoints || !this.paintState) return '';
        if (this.paintState) {
            const videoLen = this.polygonsMapData[this.selectActive].vertices.length;
            if (polygonPoints === videoLen - 1)
                return 'mouse-bg-finish';
            return `mouse-bg-${polygonPoints + 1}`;
        }
        else {
            return '';
        }
    }
    get currentDeviceDetails() {
        return DeviceIdDataModule.currentDeviceDetails;
    }
    init() {
        const { type } = this.$route.query;
        if (type === 'detail') {
            this.isShow = true;
        }
        else {
            this.isShow = false;
        }
    }
    onchangeReginId(val) {
        this.getRegionId(val);
    }
    onchangeRtspUrl(val) {
        this.getRtspUrl(val);
        this.deviceId = DeviceIdDataModule?.deviceId;
    }
    onchangeCrrentRoi(val) {
        this.polygons = val;
        let data;
        if (!isEmpty(val)) {
            data = val.map((item) => {
                return {
                    ...item,
                    statusImg: this.uncheckedImg,
                    drawerStatus: false,
                };
            });
            this.polygonsMapData = data;
        }
    }
    onchangeCrrentRoiMap(val) {
        let data = [];
        val?.forEach((item) => {
            data.push(item);
            this.polygonsMapData.forEach((it, index) => {
                if (item.id === it.id) {
                    this.polygonsMapData[index].statusImg = this.selectImg;
                }
            });
        });
        this.roiList = data;
    }
    mounted() {
        this.setDeviceList();
    }
    beforeDestroy() {
        // DeviceIdDataModule.markMapData.clear();
    }
    onStart() {
        this.progress = 0;
        // this.isLoading = true;
    }
    onEnd() {
        // this.isLoading = false;
    }
    onError(err) {
        // this.isLoading = false;
        console.log(err);
    }
    onProgress(progress) {
        this.progress = Number((parseInt(String((progress.loaded / progress.total) * 1000)) / 10).toFixed(2));
    }
    setDeviceList() {
        if (this.currentDeviceDetails && Object.keys(this.currentDeviceDetails).length > 0) {
            const { vertices, status, id, name } = this.currentDeviceDetails;
            this.deviceList = [
                {
                    vertices: vertices,
                    status: status,
                    name: name,
                    vueConfig: {
                        instance: MapDeviceIcon,
                        data: {
                            status: status,
                            deviceId: id,
                        },
                    },
                },
            ];
        }
    }
    getRtspUrl(url) {
        this.rtspAddress = url;
    }
    async getRegionId(zoneId) {
        if (!isEmpty(zoneId)) {
            await Service.getQueryDeviceDetail([zoneId]).then((res) => {
                if (!isEmpty(res)) {
                    const id = res[0]?.zoneId;
                    this.getMapInformation(id);
                }
            });
        }
    }
    async getMapInformation(zoneId) {
        this.loading = true;
        await Service.fetchMapDetail({
            zoneId: zoneId,
            checkZoneTaskAlive: false,
            bizTaskTypeEnum: '',
            externalBizFrom: '',
        })
            .then((res) => {
            if (res) {
                this.mapUrl = res.mapImageUrl;
                this.mapType = res.mapType;
                this.mapConfig = JSON.parse(res.mapConfig);
            }
        })
            .finally(() => {
            this.loading = false;
        });
    }
    formatPolygons(val) {
        const dom = document.querySelector('.map-box');
        const mapDom = this.$refs.mapEnd;
        const rectInfor = dom.getBoundingClientRect();
        const offSetLeft = rectInfor.left;
        const offSetTop = rectInfor.top;
        const h = this.styleProp.height;
        const w = this.styleProp.width;
        let mapPolygons = [];
        if (!isEmpty(val) && w && h) {
            cloneDeep(val).forEach((item) => {
                mapPolygons = item.vertices.map((item) => {
                    const { relativePosition } = mapDom.clientToMapPosition(Number(item.x) * Number(w) + offSetLeft, Number(item.y) * Number(h) + offSetTop);
                    return {
                        x: relativePosition.x,
                        y: relativePosition.y,
                        z: 0,
                    };
                });
            });
        }
        return mapPolygons;
    }
    getMapdrawend(data) {
        if (!isEmpty(data)) {
            const len = data[0]?.vertices.length;
            const id = data[0]?.id;
            const mapLen = this.polygonsMapData[this.selectActive].vertices.length;
            if (len !== mapLen) {
                this.$message.error(this.$t('mapRoiError').toString());
                const darwerDom = this.$refs.simpleDrawer;
                this.$nextTick(() => {
                    darwerDom.deleteGraph(id);
                    this.paintState = false;
                    this.selectActive = -1;
                });
            }
            else {
                this.paintState = false;
                if (this.mapType === '3D-Three.js') {
                    const dom = this.$refs.mapEnd;
                    const datalist = [];
                    // let id: string = '';
                    data?.forEach((item) => {
                        // id = item.id;
                        item.vertices?.forEach((vertice) => {
                            vertice.x = vertice.x * 2 - 1;
                            vertice.y = 1 - vertice.y * 2;
                            const itemData = {
                                ...dom.getWorldPosition(vertice),
                            };
                            datalist.push(itemData);
                        });
                    });
                    const roiMap = {
                        vertices: datalist,
                        id: this.mapId,
                        type: 'roi3d',
                    };
                    // this.setDeviceIdMap('MAP', [roiMap]);
                    DeviceIdDataModule.markMapData.set(this.mapId, roiMap);
                }
                if (this.mapType === '2D') {
                    const roi = this.formatPolygons(data);
                    const dataItem = {
                        vertices: roi,
                        id: this.mapId,
                    };
                    DeviceIdDataModule.markMapData.set(this.mapId, dataItem);
                }
                if (DeviceIdDataModule.markMapData) {
                    const roiListData = [];
                    DeviceIdDataModule.markMapData.forEach((item) => {
                        roiListData.push(item);
                    });
                    this.roiList = roiListData;
                }
                const datapoyson = DeviceIdDataModule?.deviceIdRequestParams.get(this.deviceId);
                datapoyson?.titleList?.forEach((item) => {
                    let status = false;
                    if (item.type === 'MAP') {
                        item.data = DeviceIdDataModule.markMapData;
                    }
                    if (item.type === 'ROI') {
                        status = item.data.every((item) => DeviceIdDataModule.markMapData.has(item.id) === true);
                        datapoyson.titleList[2].isComplete = status;
                    }
                });
                const allIsComplete = datapoyson?.titleList.every((item) => item.isComplete === true);
                datapoyson.isComplete = allIsComplete;
                const mapIsComplete = datapoyson?.titleList[2].isComplete; // 地图画完
                DeviceIdDataModule?.updataIsMapData(mapIsComplete);
                DeviceIdDataModule?.updataMapData(allIsComplete);
                DeviceIdDataModule?.deviceIdRequestParams.set(this.deviceId, datapoyson);
                // }
                this.polygonsMapData[this.selectActive].statusImg = this.selectImg;
                this.polygonsMapData[this.selectActive].drawerStatus = true;
                this.selectActive = -1;
                const darwerDom = this.$refs.simpleDrawer;
                const { id } = data[0];
                this.$nextTick(() => {
                    darwerDom.deleteGraph(id);
                });
                this.mode = 'normal';
            }
        }
    }
    handleDrawEnd() { }
    setDeviceIdMap(type, val) {
        const data = DeviceIdDataModule?.deviceIdRequestParams.get(this.deviceId);
        if (!isEmpty(data)) {
            data?.titleList.forEach((item) => {
                if (item.type === type) {
                    item.data = val;
                    if (!isEmpty(val)) {
                        if (type === 'MAP') {
                            const len = val?.length;
                            if (len >= 2) {
                                item.isComplete = true;
                            }
                            else {
                                item.isComplete = false;
                            }
                        }
                        else {
                            item.isComplete = true;
                        }
                    }
                    else {
                        item.isComplete = false;
                    }
                }
            });
            const allIsComplete = data?.titleList.every((item) => item.isComplete === true);
            data.isComplete = allIsComplete;
            DeviceIdDataModule?.deviceIdRequestParams.set(this.deviceId, data);
            DeviceIdDataModule.updataMonitoringIndex();
        }
    }
    selectChange(index, mapId) {
        this.mode = 'mark';
        const isMapStatus = DeviceIdDataModule.markMapData.has(mapId);
        this.showPoints = true;
        if (isMapStatus) {
            DeviceIdDataModule.markMapData.delete(mapId);
        }
        DeviceIdDataModule?.updataMapData(false);
        // this.loading = true;
        this.mapId = mapId;
        if (this.selectActive === index) {
            this.selectActive = -1;
            this.paintState = false;
            this.polygonsMapData[index].statusImg = this.uncheckedImg;
            // // this.polygonsMapData[index].drawerStatus = false;
        }
        else if (this.polygonsMapData[index].statusImg === this.selectImg && this.selectActive !== index) {
            this.paintState = true;
            this.polygonsMapData[index].statusImg = this.uncheckedImg;
            this.selectActive = index;
            const curIdx = this.roiList.findIndex((item) => item.id === mapId);
            this.roiList.splice(curIdx, 1);
            DeviceIdDataModule?.updataIsMapData(false);
        }
        else {
            this.paintState = true;
            this.selectActive = index;
            if (this.polygonsMapData[index].drawerStatus) {
                this.polygonsMapData[index].drawerStatus = false;
                this.polygonsMapData[index].statusImg = this.uncheckedImg;
            }
        }
    }
};
__decorate([
    Watch('$route', { immediate: true, deep: true })
], MarkMap.prototype, "init", null);
__decorate([
    Watch('getCrrentDeviceId', { immediate: true, deep: true })
], MarkMap.prototype, "onchangeReginId", null);
__decorate([
    Watch('getCrrentRtspUrl', { immediate: true })
], MarkMap.prototype, "onchangeRtspUrl", null);
__decorate([
    Watch('getCrrentRoi', { immediate: true, deep: true })
], MarkMap.prototype, "onchangeCrrentRoi", null);
__decorate([
    Watch('getCrrentRoiMap', { immediate: true, deep: true })
], MarkMap.prototype, "onchangeCrrentRoiMap", null);
MarkMap = __decorate([
    Component({
        name: 'MarkMap',
        components: {
            'st-drawer': Drawer,
            'st-map': maputil,
            'st-video-drawer': VideoDrawer,
        },
        i18n: {
            messages: {
                en: {
                    mapTip: "this ROI area haven't drawn in map",
                    mapRoiError: 'The number of sides of the ROI on the map must be the same as that of the corresponding ROI in the video',
                },
                zh: {
                    mapTip: '这个ROI区域还没有绘制在地图上',
                    mapRoiError: '地图上ROI的边数必须和视频中对应ROI的边数相同',
                },
            },
        },
    })
], MarkMap);
export default MarkMap;
